import { render, staticRenderFns } from "./ModalStatusOrder.vue?vue&type=template&id=1f856d76&"
import script from "./ModalStatusOrder.vue?vue&type=script&lang=js&"
export * from "./ModalStatusOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports